import { selectPlaygroundIsLoading, selectPlaygroundStatus } from './playgroundSlice'
import ViewProvider from './context/view/Provider'
import { useReduxSelector } from 'store'
import { STATUS } from 'utils/constants'
import Loading from 'components/Loading'
import Background from './Background'
import Objects from './Objects'
import Alerts from './Alerts'
import Place from './Place'
import Stage from './Stage'
import React from 'react'
import './style.scss'

const Playground: React.FC = () => {
  const status = useReduxSelector(selectPlaygroundStatus)
  const isLoading = useReduxSelector(selectPlaygroundIsLoading)
  const playgroundRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    const onWheel = (e: WheelEvent) => e.preventDefault()
    const playground = playgroundRef.current

    if (playground) {
      playground.addEventListener('wheel', onWheel, { passive: false })
      return () => playground.removeEventListener('wheel', onWheel)
    }
  }, [])

  return (
    <>
      {status === STATUS.succeed && <Alerts />}
      <div
        ref={playgroundRef}
        className='map__playground'>
        <ViewProvider>
          {status === STATUS.succeed
            ? <Stage>
              <Background />
              <Place />
              <Objects />
            </Stage>
            : status === STATUS.failed
              ? <h2>Nie udało sie pobrać mapy</h2>
              : <Loading />}
          {status === 'succeed' && isLoading && <Loading middleOfPage />}
        </ViewProvider>
      </div>
    </>
  )
}

export default Playground